import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const el = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(el);
// Drop static index.html splash so embedded / a11y clients do not stay stuck on the shell text.
document.body.classList.add('loaded');
document.querySelector('.loading-screen')?.remove();
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
